import type { CanBuilder } from "../types";
import type {
	GetAiaQuestionnaireApiResponse,
	GetApplicationApiResponse,
	GetEpsQuestionnaireApiResponse,
} from "@/services/schemas";

export function defineComitRules(can: CanBuilder): void {
	can(
		"deliberate",
		"AIAQuestionnaire",
		({ status }: { status: GetAiaQuestionnaireApiResponse["status"][0]["label"] }) =>
			status === "Aguardando Homologação",
	);

	can(
		"deliberate",
		"EPSQuestionnaire",
		({ status }: { status: GetEpsQuestionnaireApiResponse["status"][0]["label"] }) =>
			status === "Aguardando Homologação",
	);

	can(
		"deliberate",
		"Application",
		({ evaluation }: { evaluation: GetApplicationApiResponse["evaluation"]["status"] }) =>
			evaluation === "Aguardando parecer",
	);
}
